<template>
  <div class="dynamics">
    <mainPage :menus="menus"
              pageTitle="联盟动态"
              :propActiveMenu="activeMenu"
              @handleMainMenu="handleMainMenu">
      <div v-loading="loadState">
        <div v-if="!allianceData.length" class="no-data"><i class="iconfont icon-zanwushuju"></i>{{$t('common.noData')}}</div>
        <div v-if="activeMenu === '1'">
          <div v-for="(item, i) in allianceData" :key="i" class="dynamics_item flex-width">
            <div class="cover">
              <img :src="item.coverImage" alt="">
            </div>
            <div class="content">
              <div class="title" @click="detailInfo(item)">{{item.title}}</div>
              <div class="date">发布时间：{{item.createTime}}</div>
              <div class="desc">{{item.summary}}</div>
              <div class="btn" @click="detailInfo(item)">
                了解详情 <i class="iconfont icon-jiantou"></i>
              </div>
            </div>
          </div>
        </div>
        <!-- 成员风采 -->
        <div v-if="activeMenu === '2'">
          <div v-for="(item, i) in allianceData" :key="i" class="dynamics_item flex-width">
            <div class="logo">
              <img :src="item.logoUrl" alt="">
            </div>
            <div style="flex: 1;padding-left: 30px">
              <div class="name">{{item.name}}</div>
              <el-row :gutter="10" class="flex_row">
                <el-col :span="8">
                  <span class="label">成员类型：</span>
                  <span class="value">{{getSelectDesc(item.type, enumeration.allianceMemberTypes, 'value', 'label')}}</span>
                </el-col>
                <el-col :span="8">
                  <span class="label">所属行业：</span>
                  <span class="value">{{item.industry}}</span>
                </el-col>
                <el-col :span="8">
                  <span class="label">所在国家：</span>
                  <span class="value">{{item.country}}</span>
                </el-col>
                <el-col :span="8">
                  <span class="label">联系人姓名：</span>
                  <span class="value">{{item.contact}}</span>
                </el-col>
                <el-col :span="8">
                  <span class="label">联系电话：</span>
                  <span class="value">{{item.phone}}</span>
                </el-col>
                <el-col :span="8">
                  <span class="label">邮箱：</span>
                  <span class="value">{{item.email}}</span>
                </el-col>
                <el-col :span="8">
                  <span class="label">详细地址：</span>
                  <span class="value">{{item.address}}</span>
                </el-col>
                <el-col :span="8">
                  <span class="label">官方网站：</span>
                  <span class="value">{{item.website}}</span>
                </el-col>
                <el-col :span="8">
                  <span class="label">加入日期：</span>
                  <span class="value">{{item.joinDate}}</span>
                </el-col>
              </el-row>
              <div class="desc">{{item.description}}</div>
            </div>
          </div>
        </div>
      </div>
      <el-pagination
        background
        :page-size="pageSize"
        :page-count="pageCount"
        layout="prev, pager, next, total"
        :total="5"
        style="text-align: center">
      </el-pagination>
    </mainPage>
  </div>
</template> 

<script>
import mainPage from './layout/main-page'
import {enumeration} from '@/assets/js/enumeration.js'

export default {
  name: 'dynamics',
  components: { 
    mainPage
  },
  data () {
    return {
      enumeration,
      pageCount: 1,
      pageSize: 5,
      loadState: false,
      activeMenu: '1',
      menus: [
        {value: '1', label: '联盟新闻'},
        {value: '2', label: '成员风采'},
      ],
      allianceData: [],
    }
  },
  filters: {
  },
  computed: {
    localeLang: {
      get () { return this.$store.state.common.localeLang },
    }
  },
  watch: {
    localeLang (val) {
      this.handleMainMenu()
    }
  },
  mounted () {
    this.handleMainMenu()
  },
  methods: {
    detailInfo (item) {
      const routeUrl = this.$router.resolve({
        path: '/info',
        query: {id: item.id}
      })
      window.open(routeUrl.href, '_blank')
    },
    handleMainMenu (val) {
      if (val) this.activeMenu = val.value
      this.loadState = true
      let httpData = {}
      if (this.activeMenu === '2') {
        httpData = {
          url: this.$http.adornUrl(window.SITE_CONFIG.basContextPath + '/allianceMember/list'),
          method: 'post',
          data: {
            pageNum: 1,
            pageSize: 5,
            data: {
              lang: this.localeLang
            }
          }
        }
      } else {
        httpData = {
          url: this.$http.adornUrl(window.SITE_CONFIG.basContextPath + '/contentManagement/list'),
          method: 'post',
          data: {
            pageNum: 1,
            pageSize: 5,
            data: {
              contentType: 1, // 新闻动态
              lang: this.localeLang
            }
          }
        }
      }
      this.$http(httpData).then(res => {
        if (res.data && res.data.code === 'C0000') {
          this.allianceData = res.data.result.list || []
        }
      }).finally(() => {
        this.loadState = false
      })
    },
  }
}
</script>

<style lang="scss">
.dynamics{
  .dynamics_item{
    display: flex;
    padding-bottom: 20px;
    border-bottom: 1px solid #e1e1e1;
    margin-bottom: 20px;
    .cover{
      width: 320px;
      height: 220px;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .content{
      flex: 1;
      padding-left: 20px;
      .title{
        font-size: 22px;
        font-weight: bold;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
      }
      .date{
        color: #999;
        margin: 14px 0;
        font-size: 14px;
      }
      .desc{
        color: #444444;
        font-size: 16px;
        line-height: 28px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
      }
      .btn{
        float: right;
        color: #386bb1;
        font-size: 18px;
        margin-top: 20px;
        cursor: pointer;
      }
    }
    .logo{
      width: 120px;
      img{
        width: 100%;
        max-width: 100%;
        max-height: 100%;
      }
    }
    .desc{
      color: #999;
      margin-top: 10px;
    }
    .name{
      font-weight: bold;
      margin-bottom: 4px
    }
    .flex_row{
      .el-col{
        margin: 6px 0;
      }
      .label{
        color: #888;
        font-size: 14px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/dynamics.vue